'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// see node_modules/react-laag/dist/PlacementType.d.ts
exports.Placements = void 0;
(function(Placements) {
    Placements["BottomCenter"] = 'bottom-center';
    Placements["BottomEnd"] = 'bottom-end';
    Placements["BottomStart"] = 'bottom-start';
    Placements["Center"] = 'center';
    Placements["LeftCenter"] = 'left-center';
    Placements["LeftEnd"] = 'left-end';
    Placements["LeftStart"] = 'left-start';
    Placements["RightCenter"] = 'right-center';
    Placements["RightEnd"] = 'right-end';
    Placements["RightStart"] = 'right-start';
    Placements["TopCenter"] = 'top-center';
    Placements["TopEnd"] = 'top-end';
    Placements["TopStart"] = 'top-start';
})(exports.Placements || (exports.Placements = {}));
//# sourceMappingURL=placements.js.map
